function r(r,t){for(var n=String(r);n.length<t;)n="0"+n;return n}export{r as default};
